// extracted by mini-css-extract-plugin
export default {"colors":"Y2gBMujzLAk1A_vDwiRn","wrapper":"KmkektjZX_ygyYDYxkFC","dialog__item":"WrNDuy3p12DWhY3CZhDa"};